import React from "react";
import PropTypes from "prop-types";
import { Backdrop, Box, Typography } from "@material-ui/core";

const SendAllProgress = ({ open, progress, current, total }) => (
  <Backdrop open={open} style={{ zIndex: 99999, color: "#fff" }}>
    <Box style={{ width: 420, maxWidth: "90%", textAlign: "center" }}>
      <Typography style={{ fontSize: 18, fontWeight: 600, marginBottom: 20 }}>
        Sending Invoices...
      </Typography>

      <Box
        style={{
          width: "100%",
          height: 10,
          backgroundColor: "rgba(255,255,255,0.25)",
          borderRadius: 10,
          overflow: "hidden",
        }}
      >
        <Box
          style={{
            width: `${progress}%`,
            height: "100%",
            backgroundColor: "#fff",
            transition: "width 0.3s ease",
          }}
        />
      </Box>

      <Typography style={{ fontSize: 28, fontWeight: 700, marginTop: 15 }}>
        {progress}%
      </Typography>

      <Typography style={{ fontSize: 13, marginTop: 6, opacity: 0.9 }}>
        {current} / {total} invoices processed
      </Typography>
    </Box>
  </Backdrop>
);

SendAllProgress.propTypes = {
  open: PropTypes.bool.isRequired,
  progress: PropTypes.number,
  current: PropTypes.number,
  total: PropTypes.number,
};

SendAllProgress.defaultProps = {
  progress: 0,
  current: 0,
  total: 0,
};

export default SendAllProgress;
